import GeneratedMessageStore from "./generated/GeneratedMessageStore"

class MessageStore extends GeneratedMessageStore {

}

export const messageStore = new MessageStore()
